import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("reliable-faq", {
    model: {
      defaults: {
        components: html`
          <section class="container mx-auto md:px-10 md:pt-5" id="curious">
            <div class="p-4 md:py-7 ">
              <div>
                <div class="flex gap-2 items-center">
                  <div class="bg-amber-600 w-1 md:h-12 h-6 inline-block"></div>
                  <h3
                    class="text-xl md:text-4xl text-[#0083D7] font-bold font-roboto p-1 tracking-normal whitespace-nowrap"
                  >
                    Curious? We've Got You Covered
                  </h3>
                </div>
                <button
                  class="font-roboto py-2 px-6 mt-4 tracking-normal text-lg md:text-2xl text-gray-300 border rounded-lg border-gray-300 hover:bg-[#FA6914] hover:text-white group-hover:text-white flex items-center gap-x-3"
                >
                  Learn more
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 10.9999L16.586 10.9999L12.086 6.49994L13.5 5.08594L20.414 11.9999L13.5 18.9139L12.086 17.4999L16.586 12.9999L5 12.9999L5 10.9999Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </button>
              </div>
              <div class="flex flex-wrap gap-5 md:mt-12 mt-8 ">
                <div class="w-full md:w-[48%] ">
                  <div
                    class="faq-item flex flex-col items-center justify-center p-3 rounded-lg shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)] md:p-6 w-full max-w-3xl mx-auto"
                  >
                    <div
                      class="faq-toggle flex items-center justify-between gap-6 cursor-pointer w-full"
                    >
                      <p
                        class="text-lg md:text-2xl font-bold font-roboto text-[#272727] tracking-wide text-center"
                      >
                        Service Time Frame
                      </p>
                      <div
                        class="md:size-12 size-8 flex items-center justify-center bg-blue-500 rounded-full flex-shrink-0"
                      >
                        <svg
                          viewBox="0 0 62 62"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="faq-icon transition-all md:w-16 w-10"
                        >
                          <rect
                            width="62"
                            height="62"
                            rx="31"
                            fill="#0083D7"
                          ></rect>
                          <path
                            d="M41.9541 32.5202H32.5246V41.9497C32.5246 42.4499 32.326 42.9296 31.9723 43.2832C31.6186 43.6369 31.1389 43.8356 30.6388 43.8356C30.1386 43.8356 29.6589 43.6369 29.3052 43.2832C28.9516 42.9296 28.7529 42.4499 28.7529 41.9497V32.5202H19.3234C18.8232 32.5202 18.3435 32.3216 17.9899 31.9679C17.6362 31.6142 17.4375 31.1345 17.4375 30.6344C17.4375 30.1342 17.6362 29.6545 17.9899 29.3008C18.3435 28.9472 18.8232 28.7485 19.3234 28.7485H28.7529V19.319C28.7529 18.8188 28.9516 18.3391 29.3052 17.9855C29.6589 17.6318 30.1386 17.4331 30.6388 17.4331C31.1389 17.4331 31.6186 17.6318 31.9723 17.9855C32.326 18.3391 32.5246 18.8188 32.5246 19.319V28.7485H41.9541C42.4543 28.7485 42.934 28.9472 43.2876 29.3008C43.6413 29.6545 43.84 30.1342 43.84 30.6344C43.84 31.1345 43.6413 31.6142 43.2876 31.9679C42.934 32.3216 42.4543 32.5202 41.9541 32.5202Z"
                            fill="#FEFEFE"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      class="faq-content hidden transition-all duration-300 text-black font-roboto text-lg leading-6 mt-2 px-2"
                    >
                      <p>
                        Our servicing time frame ensures prompt handling and
                        delivery of your cargo, meeting your deadlines
                        efficiently
                      </p>
                    </div>
                  </div>
                </div>
                 <div class="w-full md:w-[48%] ">
                  <div
                    class="faq-item flex flex-col items-center justify-center p-3 rounded-lg shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)] md:p-6 w-full max-w-3xl mx-auto"
                  >
                    <div
                      class="faq-toggle flex items-center justify-between gap-6 cursor-pointer w-full"
                    >
                      <p
                        class="text-lg md:text-2xl font-bold font-roboto text-[#272727] tracking-wide text-center"
                      >
                        Service Time Frame
                      </p>
                      <div
                        class="md:size-12 size-8 flex items-center justify-center bg-blue-500 rounded-full flex-shrink-0"
                      >
                        <svg
                          viewBox="0 0 62 62"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="faq-icon transition-all md:w-16 w-10"
                        >
                          <rect
                            width="62"
                            height="62"
                            rx="31"
                            fill="#0083D7"
                          ></rect>
                          <path
                            d="M41.9541 32.5202H32.5246V41.9497C32.5246 42.4499 32.326 42.9296 31.9723 43.2832C31.6186 43.6369 31.1389 43.8356 30.6388 43.8356C30.1386 43.8356 29.6589 43.6369 29.3052 43.2832C28.9516 42.9296 28.7529 42.4499 28.7529 41.9497V32.5202H19.3234C18.8232 32.5202 18.3435 32.3216 17.9899 31.9679C17.6362 31.6142 17.4375 31.1345 17.4375 30.6344C17.4375 30.1342 17.6362 29.6545 17.9899 29.3008C18.3435 28.9472 18.8232 28.7485 19.3234 28.7485H28.7529V19.319C28.7529 18.8188 28.9516 18.3391 29.3052 17.9855C29.6589 17.6318 30.1386 17.4331 30.6388 17.4331C31.1389 17.4331 31.6186 17.6318 31.9723 17.9855C32.326 18.3391 32.5246 18.8188 32.5246 19.319V28.7485H41.9541C42.4543 28.7485 42.934 28.9472 43.2876 29.3008C43.6413 29.6545 43.84 30.1342 43.84 30.6344C43.84 31.1345 43.6413 31.6142 43.2876 31.9679C42.934 32.3216 42.4543 32.5202 41.9541 32.5202Z"
                            fill="#FEFEFE"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      class="faq-content hidden transition-all duration-300 text-black font-roboto text-lg leading-6 mt-2 px-2"
                    >
                      <p>
                        Our servicing time frame ensures prompt handling and
                        delivery of your cargo, meeting your deadlines
                        efficiently
                      </p>
                    </div>
                  </div>
                </div>
                 <div class="w-full md:w-[48%] ">
                  <div
                    class="faq-item flex flex-col items-center justify-center p-3 rounded-lg shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)] md:p-6 w-full max-w-3xl mx-auto"
                  >
                    <div
                      class="faq-toggle flex items-center justify-between gap-6 cursor-pointer w-full"
                    >
                      <p
                        class="text-lg md:text-2xl font-bold font-roboto text-[#272727] tracking-wide text-center"
                      >
                        Service Time Frame
                      </p>
                      <div
                        class="md:size-12 size-8 flex items-center justify-center bg-blue-500 rounded-full flex-shrink-0"
                      >
                        <svg
                          viewBox="0 0 62 62"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="faq-icon transition-all md:w-16 w-10"
                        >
                          <rect
                            width="62"
                            height="62"
                            rx="31"
                            fill="#0083D7"
                          ></rect>
                          <path
                            d="M41.9541 32.5202H32.5246V41.9497C32.5246 42.4499 32.326 42.9296 31.9723 43.2832C31.6186 43.6369 31.1389 43.8356 30.6388 43.8356C30.1386 43.8356 29.6589 43.6369 29.3052 43.2832C28.9516 42.9296 28.7529 42.4499 28.7529 41.9497V32.5202H19.3234C18.8232 32.5202 18.3435 32.3216 17.9899 31.9679C17.6362 31.6142 17.4375 31.1345 17.4375 30.6344C17.4375 30.1342 17.6362 29.6545 17.9899 29.3008C18.3435 28.9472 18.8232 28.7485 19.3234 28.7485H28.7529V19.319C28.7529 18.8188 28.9516 18.3391 29.3052 17.9855C29.6589 17.6318 30.1386 17.4331 30.6388 17.4331C31.1389 17.4331 31.6186 17.6318 31.9723 17.9855C32.326 18.3391 32.5246 18.8188 32.5246 19.319V28.7485H41.9541C42.4543 28.7485 42.934 28.9472 43.2876 29.3008C43.6413 29.6545 43.84 30.1342 43.84 30.6344C43.84 31.1345 43.6413 31.6142 43.2876 31.9679C42.934 32.3216 42.4543 32.5202 41.9541 32.5202Z"
                            fill="#FEFEFE"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      class="faq-content hidden transition-all duration-300 text-black font-roboto text-lg leading-6 mt-2 px-2"
                    >
                      <p>
                        Our servicing time frame ensures prompt handling and
                        delivery of your cargo, meeting your deadlines
                        efficiently
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full md:w-[48%]">
                  <div
                    class="faq-item flex flex-col items-center justify-center p-3 rounded-lg shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)] md:p-6 w-full max-w-3xl mx-auto"
                  >
                    <div
                      class="faq-toggle flex items-center justify-between gap-6 cursor-pointer w-full"
                    >
                      <p
                        class="text-lg md:text-2xl font-bold font-roboto text-[#272727] tracking-wide text-center"
                      >
                        Refund Policy & Pricing
                      </p>
                      <div
                        class="md:size-12 size-8 flex items-center justify-center bg-blue-500 rounded-full flex-shrink-0"
                      >
                        <svg
                          viewBox="0 0 62 62"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="faq-icon transition-all md:w-16 w-10"
                        >
                          <rect
                            width="62"
                            height="62"
                            rx="31"
                            fill="#0083D7"
                          ></rect>
                          <path
                            d="M41.9541 32.5202H32.5246V41.9497C32.5246 42.4499 32.326 42.9296 31.9723 43.2832C31.6186 43.6369 31.1389 43.8356 30.6388 43.8356C30.1386 43.8356 29.6589 43.6369 29.3052 43.2832C28.9516 42.9296 28.7529 42.4499 28.7529 41.9497V32.5202H19.3234C18.8232 32.5202 18.3435 32.3216 17.9899 31.9679C17.6362 31.6142 17.4375 31.1345 17.4375 30.6344C17.4375 30.1342 17.6362 29.6545 17.9899 29.3008C18.3435 28.9472 18.8232 28.7485 19.3234 28.7485H28.7529V19.319C28.7529 18.8188 28.9516 18.3391 29.3052 17.9855C29.6589 17.6318 30.1386 17.4331 30.6388 17.4331C31.1389 17.4331 31.6186 17.6318 31.9723 17.9855C32.326 18.3391 32.5246 18.8188 32.5246 19.319V28.7485H41.9541C42.4543 28.7485 42.934 28.9472 43.2876 29.3008C43.6413 29.6545 43.84 30.1342 43.84 30.6344C43.84 31.1345 43.6413 31.6142 43.2876 31.9679C42.934 32.3216 42.4543 32.5202 41.9541 32.5202Z"
                            fill="#FEFEFE"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      class="faq-content hidden transition-all duration-300 text-black font-roboto text-lg leading-6 mt-2 px-2"
                    >
                      <p>
                        Our refund policy guarantees fair treatment for
                        unforeseen circumstances. Pricing is transparent,
                        reflecting our commitment to competitive rates.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full md:w-[48%]">
                  <div
                    class="faq-item flex flex-col items-center justify-center p-3 rounded-lg shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)] md:p-6 w-full max-w-3xl mx-auto"
                  >
                    <div
                      class="faq-toggle flex items-center justify-between gap-6 cursor-pointer w-full"
                    >
                      <p
                        class="text-lg md:text-2xl font-bold font-roboto text-[#272727] tracking-wide text-center"
                      >
                        Our Own Products
                      </p>
                      <div
                        class="md:size-12 size-8 flex items-center justify-center bg-blue-500 rounded-full flex-shrink-0"
                      >
                        <svg
                          viewBox="0 0 62 62"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="faq-icon transition-all md:w-16 w-10"
                        >
                          <rect
                            width="62"
                            height="62"
                            rx="31"
                            fill="#0083D7"
                          ></rect>
                          <path
                            d="M41.9541 32.5202H32.5246V41.9497C32.5246 42.4499 32.326 42.9296 31.9723 43.2832C31.6186 43.6369 31.1389 43.8356 30.6388 43.8356C30.1386 43.8356 29.6589 43.6369 29.3052 43.2832C28.9516 42.9296 28.7529 42.4499 28.7529 41.9497V32.5202H19.3234C18.8232 32.5202 18.3435 32.3216 17.9899 31.9679C17.6362 31.6142 17.4375 31.1345 17.4375 30.6344C17.4375 30.1342 17.6362 29.6545 17.9899 29.3008C18.3435 28.9472 18.8232 28.7485 19.3234 28.7485H28.7529V19.319C28.7529 18.8188 28.9516 18.3391 29.3052 17.9855C29.6589 17.6318 30.1386 17.4331 30.6388 17.4331C31.1389 17.4331 31.6186 17.6318 31.9723 17.9855C32.326 18.3391 32.5246 18.8188 32.5246 19.319V28.7485H41.9541C42.4543 28.7485 42.934 28.9472 43.2876 29.3008C43.6413 29.6545 43.84 30.1342 43.84 30.6344C43.84 31.1345 43.6413 31.6142 43.2876 31.9679C42.934 32.3216 42.4543 32.5202 41.9541 32.5202Z"
                            fill="#FEFEFE"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      class="faq-content hidden transition-all duration-300 text-black font-roboto text-lg  leading-6 mt-2 px-2"
                    >
                      <p>
                        We take pride in offering our own line of products,
                        designed to meet the specific needs and standards of our
                        customers
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full md:w-[48%]">
                  <div
                    class="faq-item flex flex-col items-center justify-center p-3 rounded-lg shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)] md:p-6 w-full max-w-3xl mx-auto"
                  >
                    <div
                      class="faq-toggle flex items-center justify-between gap-6 cursor-pointer w-full"
                    >
                      <p
                        class="text-lg md:text-2xl font-bold font-roboto text-[#272727] tracking-wide text-center"
                      >
                        Troubleshooting Process
                      </p>
                      <div
                        class="md:size-12 size-8 flex items-center justify-center bg-blue-500 rounded-full flex-shrink-0"
                      >
                        <svg
                          viewBox="0 0 62 62"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="faq-icon transition-all md:w-16 w-10"
                        >
                          <rect
                            width="62"
                            height="62"
                            rx="31"
                            fill="#0083D7"
                          ></rect>
                          <path
                            d="M41.9541 32.5202H32.5246V41.9497C32.5246 42.4499 32.326 42.9296 31.9723 43.2832C31.6186 43.6369 31.1389 43.8356 30.6388 43.8356C30.1386 43.8356 29.6589 43.6369 29.3052 43.2832C28.9516 42.9296 28.7529 42.4499 28.7529 41.9497V32.5202H19.3234C18.8232 32.5202 18.3435 32.3216 17.9899 31.9679C17.6362 31.6142 17.4375 31.1345 17.4375 30.6344C17.4375 30.1342 17.6362 29.6545 17.9899 29.3008C18.3435 28.9472 18.8232 28.7485 19.3234 28.7485H28.7529V19.319C28.7529 18.8188 28.9516 18.3391 29.3052 17.9855C29.6589 17.6318 30.1386 17.4331 30.6388 17.4331C31.1389 17.4331 31.6186 17.6318 31.9723 17.9855C32.326 18.3391 32.5246 18.8188 32.5246 19.319V28.7485H41.9541C42.4543 28.7485 42.934 28.9472 43.2876 29.3008C43.6413 29.6545 43.84 30.1342 43.84 30.6344C43.84 31.1345 43.6413 31.6142 43.2876 31.9679C42.934 32.3216 42.4543 32.5202 41.9541 32.5202Z"
                            fill="#FEFEFE"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      class="faq-content hidden transition-all duration-300 text-black font-roboto text-lg leading-6 mt-2 px-2"
                    >
                      <p>
                        Our troubleshooting process is designed to swiftly
                        identify and resolve any issues that may arise, ensuring
                        minimal disruption to your cargo shipments.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full md:w-[48%]">
                  <div
                    class="faq-item flex flex-col items-center justify-center p-3 rounded-lg shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)] md:p-6 w-full max-w-3xl mx-auto"
                  >
                    <div
                      class="faq-toggle flex items-center justify-between gap-6 cursor-pointer w-full"
                    >
                      <p
                        class="text-lg md:text-2xl font-bold font-roboto text-[#272727] tracking-wide text-center"
                      >
                        Terms & Conditions
                      </p>
                      <div
                        class="md:size-12 size-8 flex items-center justify-center bg-blue-500 rounded-full flex-shrink-0"
                      >
                        <svg
                          viewBox="0 0 62 62"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="faq-icon transition-all md:w-16 w-10"
                        >
                          <rect
                            width="62"
                            height="62"
                            rx="31"
                            fill="#0083D7"
                          ></rect>
                          <path
                            d="M41.9541 32.5202H32.5246V41.9497C32.5246 42.4499 32.326 42.9296 31.9723 43.2832C31.6186 43.6369 31.1389 43.8356 30.6388 43.8356C30.1386 43.8356 29.6589 43.6369 29.3052 43.2832C28.9516 42.9296 28.7529 42.4499 28.7529 41.9497V32.5202H19.3234C18.8232 32.5202 18.3435 32.3216 17.9899 31.9679C17.6362 31.6142 17.4375 31.1345 17.4375 30.6344C17.4375 30.1342 17.6362 29.6545 17.9899 29.3008C18.3435 28.9472 18.8232 28.7485 19.3234 28.7485H28.7529V19.319C28.7529 18.8188 28.9516 18.3391 29.3052 17.9855C29.6589 17.6318 30.1386 17.4331 30.6388 17.4331C31.1389 17.4331 31.6186 17.6318 31.9723 17.9855C32.326 18.3391 32.5246 18.8188 32.5246 19.319V28.7485H41.9541C42.4543 28.7485 42.934 28.9472 43.2876 29.3008C43.6413 29.6545 43.84 30.1342 43.84 30.6344C43.84 31.1345 43.6413 31.6142 43.2876 31.9679C42.934 32.3216 42.4543 32.5202 41.9541 32.5202Z"
                            fill="#FEFEFE"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      class="faq-content hidden transition-all duration-300 text-black font-roboto text-lg  leading-6 mt-2 px-2"
                    >
                      <p>
                        Please review our terms and conditions for comprehensive
                        information on our services, including policies on
                        shipment, liability, and payment obligations
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full md:w-[48%]">
                  <div
                    class="faq-item flex flex-col items-center justify-center p-3 rounded-lg shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)] md:p-6 w-full max-w-3xl mx-auto"
                  >
                    <div
                      class="faq-toggle flex items-center justify-between gap-6 cursor-pointer w-full"
                    >
                      <p
                        class="text-lg md:text-2xl font-bold font-roboto text-[#272727] tracking-wide text-center"
                      >
                        Can I track my shipment?
                      </p>
                      <div
                        class="md:size-12 size-8 flex items-center justify-center bg-blue-500 rounded-full flex-shrink-0"
                      >
                        <svg
                          viewBox="0 0 62 62"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="faq-icon transition-all md:w-16 w-10"
                        >
                          <rect
                            width="62"
                            height="62"
                            rx="31"
                            fill="#0083D7"
                          ></rect>
                          <path
                            d="M41.9541 32.5202H32.5246V41.9497C32.5246 42.4499 32.326 42.9296 31.9723 43.2832C31.6186 43.6369 31.1389 43.8356 30.6388 43.8356C30.1386 43.8356 29.6589 43.6369 29.3052 43.2832C28.9516 42.9296 28.7529 42.4499 28.7529 41.9497V32.5202H19.3234C18.8232 32.5202 18.3435 32.3216 17.9899 31.9679C17.6362 31.6142 17.4375 31.1345 17.4375 30.6344C17.4375 30.1342 17.6362 29.6545 17.9899 29.3008C18.3435 28.9472 18.8232 28.7485 19.3234 28.7485H28.7529V19.319C28.7529 18.8188 28.9516 18.3391 29.3052 17.9855C29.6589 17.6318 30.1386 17.4331 30.6388 17.4331C31.1389 17.4331 31.6186 17.6318 31.9723 17.9855C32.326 18.3391 32.5246 18.8188 32.5246 19.319V28.7485H41.9541C42.4543 28.7485 42.934 28.9472 43.2876 29.3008C43.6413 29.6545 43.84 30.1342 43.84 30.6344C43.84 31.1345 43.6413 31.6142 43.2876 31.9679C42.934 32.3216 42.4543 32.5202 41.9541 32.5202Z"
                            fill="#FEFEFE"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      class="faq-content hidden transition-all duration-300 text-black font-roboto text-lg leading-6 mt-2 px-2"
                    >
                      <p>
                        Yes, all international cargo shipments come with a
                        tracking number. You can monitor your shipment in
                        real-time through our tracking portal or mobile app.
                      </p>
                    </div>
                  </div>
                </div>
              </div>





            </div>


          </section>
        `,
        script: function () {
          const toggles = document.querySelectorAll(".faq-toggle");

          toggles.forEach((toggle) => {
            toggle.addEventListener("click", () => {
              const faqItem = toggle.closest(".faq-item");
              const content = faqItem.querySelector(".faq-content");
              const icon = faqItem.querySelector(".faq-icon");

              const isVisible = !content.classList.contains("hidden");

              document.querySelectorAll(".faq-content").forEach((c) => {
                c.classList.add("hidden");
              });

              if (isVisible) {
                content.classList.add("hidden");
                icon?.classList.remove("rotate-45");
              } else {
                content.classList.remove("hidden");
                icon?.classList.add("rotate-45");
              }
            });
          });
        },
      },
    },
  });
};
